export const MODAL_ID = "verify-company-modal";

export const REFERENCE_NUMBER_VALIDATION = {
  required: {
    value: true,
    message: "Loan number is required",
  },
};

export const DEPOSIT_VALUE_VALIDATION = {
  required: {
    value: true,
    message: "Deposit value is required",
  },
};

export const RATE_VALIDATION = {
  required: {
    value: true,
    message: "New rate is required",
  },
};
